import Swal from "sweetalert2";

function fire(options = {}) {
  return Swal.fire(options);
}

export default {
  install(app) {
    app.config.globalProperties.$fire = fire;
    app.config.globalProperties.$swal = Swal;
    app.provide("$fire", fire);
  }
};
